// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JoinCallButton__button-ec3308 {
  align-items: center;
  display: flex;
  color: var(--addition-50);
  background-color: var(--success-40);
  border-radius: 14px;
  padding: 0 8px 0 6px;
  height: 28px;
  margin-inline-start: 16px;
  align-self: center;
}

.JoinCallButton__button-ec3308.JoinCallButton__canPress-dd0c02:not(:disabled) {
  cursor: pointer;
}

.JoinCallButton__button-ec3308.JoinCallButton__canPress-dd0c02:hover,
.JoinCallButton__button-ec3308.JoinCallButton__canPress-dd0c02:focus {
  background-color: var(--success-50);
}

.JoinCallButton__button-ec3308.JoinCallButton__canPress-dd0c02:active {
  background-color: var(--success-60);
}

.JoinCallButton__button-ec3308:disabled {
  color: var(--success-40);
  background-color: transparent;
  padding: 0;
}

.JoinCallButton__icon-f85521 {
  fill: currentColor;
  margin-inline-end: 2px;
}

.JoinCallButton__time-c7315e {
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  padding-top: 1px;
}

.JoinCallButton__loader-active-ef7262 {
  background-color: var(--success-40);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/DefaultHeaderActions/JoinCallButton/JoinCallButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;;EAEE,mCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,wBAAA;EACA,6BAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,gBAAA;AACF;;AAEA;EACE,mCAAA;AACF","sourcesContent":[".button {\n  align-items: center;\n  display: flex;\n  color: var(--addition-50);\n  background-color: var(--success-40);\n  border-radius: 14px;\n  padding: 0 8px 0 6px;\n  height: 28px;\n  margin-inline-start: 16px;\n  align-self: center;\n}\n\n.button.canPress:not(:disabled) {\n  cursor: pointer;\n}\n\n.button.canPress:hover,\n.button.canPress:focus {\n  background-color: var(--success-50);\n}\n\n.button.canPress:active {\n  background-color: var(--success-60);\n}\n\n.button:disabled {\n  color: var(--success-40);\n  background-color: transparent;\n  padding: 0;\n}\n\n.icon {\n  fill: currentColor;\n  margin-inline-end: 2px;\n}\n\n.time {\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  padding-top: 1px;\n}\n\n.loader-active {\n  background-color: var(--success-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `JoinCallButton__button-ec3308`,
	"canPress": `JoinCallButton__canPress-dd0c02`,
	"icon": `JoinCallButton__icon-f85521`,
	"time": `JoinCallButton__time-c7315e`,
	"loader-active": `JoinCallButton__loader-active-ef7262`,
	"loaderActive": `JoinCallButton__loader-active-ef7262`
};
module.exports = ___CSS_LOADER_EXPORT___;
